// ESM-Konvertierung von lib/scripts/CLS_CCache.js (Phase 4, Welle 1b).
export class CCache {
  constructor() {
    this.entries = [];
    this.data = [];
  }

  dataToCache(id, data) { this.data[id] = data; }

  checkDataCache(id) { return typeof this.data[id] != "undefined"; }

  dataFromCache(id) { return this.data[id]; }

  // thunk: parameterlose Funktion, die den Wert bei Cache-Miss erzeugt
  // (einziger Aufrufer: CComponent.setStyleFromXML).
  toCache(id, thunk) {
    if (typeof this.entries[id] == "undefined")
      this.entries[id] = thunk();
    return this.entries[id];
  }

  fromCache(id) { return this.entries[id]; }

  datacacheToDisc(id) {
    const data = this.data[id].toString();
    this.dataFile = new CFileHandler();
    this.dataFile.fileName = "var/cache/" + id + ".dat";
    this.dataFile.open(true);
    this.dataFile.overwrite(data);
  }

  datacacheFromDisc(id) {
    this.dataFile = new CFileHandler();
    this.dataFile.fileName = "var/cache/" + id + ".dat";
    if (this.dataFile.open(false) == false)
      return false;
    this.data[id] = this.dataFile.readAll();
  }
}
